import { render, staticRenderFns } from "./Faq2.vue?vue&type=template&id=32d1c21c&scoped=true&"
import script from "./Faq2.vue?vue&type=script&lang=js&"
export * from "./Faq2.vue?vue&type=script&lang=js&"
import style0 from "./Faq2.vue?vue&type=style&index=0&id=32d1c21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d1c21c",
  null
  
)

export default component.exports